const getPreviewWidgetKey = (field) =>
  String(
    field?.field_instance_id ??
      field?.name ??
      field?.id ??
      field?.field_id ??
      "",
  );

export const isPreviewTextWidget = (field) => field?.type === "PDFTextField";

export const swapPreviewFieldOrders = (
  fields = [],
  sourceField,
  targetField,
) => {
  const sourceKey = getPreviewWidgetKey(sourceField);
  const targetKey = getPreviewWidgetKey(targetField);

  if (!sourceKey || !targetKey || sourceKey === targetKey) return fields;

  const sourceIndex = fields.findIndex(
    (field) => getPreviewWidgetKey(field) === sourceKey,
  );
  const targetIndex = fields.findIndex(
    (field) => getPreviewWidgetKey(field) === targetKey,
  );

  if (sourceIndex === -1 || targetIndex === -1) return fields;

  const sourceOrder = Number.isFinite(Number(fields[sourceIndex]?.order))
    ? fields[sourceIndex].order
    : sourceIndex;
  const targetOrder = Number.isFinite(Number(fields[targetIndex]?.order))
    ? fields[targetIndex].order
    : targetIndex;

  return fields.map((field, index) => {
    if (index === sourceIndex) return { ...field, order: targetOrder };
    if (index === targetIndex) return { ...field, order: sourceOrder };
    return field;
  });
};

export const movePreviewFieldAfter = (
  fields = [],
  sourceField,
  targetField,
) => {
  const sourceKey = getPreviewWidgetKey(sourceField);
  const targetKey = getPreviewWidgetKey(targetField);

  if (!sourceKey || !targetKey || sourceKey === targetKey) return fields;

  const orderedEntries = fields
    .map((field, index) => ({
      field,
      originalIndex: index,
      order: Number.isFinite(Number(field?.order))
        ? Number(field.order)
        : index,
    }))
    .sort(
      (first, second) =>
        first.order - second.order ||
        first.originalIndex - second.originalIndex,
    );
  const sourceIndex = orderedEntries.findIndex(
    ({ field }) => getPreviewWidgetKey(field) === sourceKey,
  );
  const targetIndex = orderedEntries.findIndex(
    ({ field }) => getPreviewWidgetKey(field) === targetKey,
  );

  if (sourceIndex === -1 || targetIndex === -1) return fields;

  const availableOrders = orderedEntries.map(({ order }) => order);
  const [targetEntry] = orderedEntries.splice(targetIndex, 1);
  const adjustedSourceIndex = orderedEntries.findIndex(
    ({ field }) => getPreviewWidgetKey(field) === sourceKey,
  );
  orderedEntries.splice(adjustedSourceIndex + 1, 0, targetEntry);

  const orderByKey = new Map(
    orderedEntries.map(({ field }, index) => [
      getPreviewWidgetKey(field),
      availableOrders[index],
    ]),
  );

  return fields.map((field) => {
    const nextOrder = orderByKey.get(getPreviewWidgetKey(field));
    return Number(field?.order) === nextOrder
      ? field
      : { ...field, order: nextOrder };
  });
};
